import { render } from "./SalesHistoricShow.vue?vue&type=template&id=6facbaa0&scoped=true"
import script from "./SalesHistoricShow.vue?vue&type=script&lang=js"
export * from "./SalesHistoricShow.vue?vue&type=script&lang=js"

import "./SalesHistoricShow.vue?vue&type=style&index=0&id=6facbaa0&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6facbaa0"]])

export default __exports__